import React from "react";

import { StyledWrapper, StyledButton } from "./pagination.style";
import chevronLeftIcon from "../../../assets/icons/chevron_left.svg";
import chevronRightIcon from "../../../assets/icons/chevron_right.svg";

const Pagination = ({ metaData, changePage }) => {
  const handlePageChange = (page) => {
    if (page === null) return;

    changePage(page);
  };

  const currentPage = metaData?.pagination?.currentPage;

  const renderPages = () => {
    if (metaData?.pagination?.prevPage === null) {
      return (
        <>
          <StyledButton
            onClick={() => handlePageChange(currentPage)}
            className="active"
          >
            {currentPage}
          </StyledButton>
          {currentPage < metaData?.pagination?.totalPages ? (
            <StyledButton onClick={() => handlePageChange(currentPage + 1)}>
              {currentPage + 1}
            </StyledButton>
          ) : null}
          {currentPage + 1 < metaData?.pagination?.totalPages ? (
            <StyledButton onClick={() => handlePageChange(currentPage + 2)}>
              {currentPage + 2}
            </StyledButton>
          ) : null}
        </>
      );
    } else if (metaData?.pagination?.nextPage === null) {
      return (
        <>
          {currentPage - 2 < 1 ? null : (
            <StyledButton onClick={() => handlePageChange(currentPage - 2)}>
              {currentPage - 2}
            </StyledButton>
          )}
          {currentPage - 1 < 1 ? null : (
            <StyledButton onClick={() => handlePageChange(currentPage - 1)}>
              {currentPage - 1}
            </StyledButton>
          )}
          <StyledButton
            onClick={() => handlePageChange(currentPage)}
            className="active"
          >
            {currentPage}
          </StyledButton>
        </>
      );
    } else {
      return (
        <>
          {currentPage - 1 < 1 ? null : (
            <StyledButton onClick={() => handlePageChange(currentPage - 1)}>
              {currentPage - 1}
            </StyledButton>
          )}
          <StyledButton
            onClick={() => handlePageChange(currentPage)}
            className="active"
          >
            {currentPage}
          </StyledButton>
          {currentPage < metaData?.pagination?.totalPages ? (
            <StyledButton onClick={() => handlePageChange(currentPage + 1)}>
              {currentPage + 1}
            </StyledButton>
          ) : null}
        </>
      );
    }
  };

  return (
    <StyledWrapper>
      <StyledButton
        className={metaData?.pagination?.prevPage ? "" : "disable"}
        onClick={() => handlePageChange(metaData?.pagination?.prevPage)}
      >
        <img src={chevronLeftIcon} alt="Previous" />
      </StyledButton>
      {renderPages()}
      <StyledButton
        className={metaData?.pagination?.nextPage ? "" : "disable"}
        onClick={() => handlePageChange(metaData?.pagination?.nextPage)}
      >
        <img src={chevronRightIcon} alt="Next" />
      </StyledButton>
    </StyledWrapper>
  );
};

export default Pagination;
